import { UserContext } from 'libs/contexts';
import { useContext } from 'react';
import { UserSource, ROLE_TYPE } from 'libs/enums';

/** 当前账号是否为外部采购商。无身份列表时视为否，避免首页渲染崩溃 */
const IsExternalPurchaserUsed = () => {
  const userInfo = useContext(UserContext);
  if (!userInfo) return false;
  return (
    console.log('userInfo666', userInfo),
    userInfo.applications?.[0]?.key === ROLE_TYPE.PURCHASER &&
    userInfo.organizationSource === UserSource.outside
  );
};

export default IsExternalPurchaserUsed;
